import { Api } from "~/api";

const BRANDS_IMAGE_SECTION = "brands";
const CERTIFICATES_FILE_SECTION = "certificates";
const S3_BASE = "https://s3.timeweb.cloud/1ba765b7-farkop-photos";

let cachedBrands = null;
let cachedCertificates = null;
let cachedContentVersion = null;

function brandImageUrl(imageId) {
  if (imageId == null) return "";
  const idStr = String(imageId).padStart(6, "0");
  const path1 = idStr.substring(0, 2);
  const path2 = idStr.substring(2, 4);
  const path3 = idStr.substring(4);
  return `/images/${BRANDS_IMAGE_SECTION}/${path1}/${path2}/${path3}/orig.jpeg`;
}

export function certificateFileUrl(fileId, format = "pdf") {
  if (fileId == null) return "";
  const idStr = String(fileId).padStart(6, "0");
  const path1 = idStr.substring(0, 2);
  const path2 = idStr.substring(2, 4);
  const path3 = idStr.substring(4);
  return `${S3_BASE}/${CERTIFICATES_FILE_SECTION}/${path1}/${path2}/${path3}/file.${format}`;
}

export function getCertificateUrl(cert) {
  const data = cert?.data || {};
  const fileStr = data.file;
  if (
    typeof fileStr === "string" &&
    (fileStr.startsWith("http") || fileStr.startsWith("/"))
  ) {
    return fileStr;
  }
  const fileId = data.fileUpload ?? data.file;
  if (fileId != null && typeof fileId === "number") {
    return certificateFileUrl(fileId);
  }
  return "";
}

export function getCertificatePhotoUrl(cert, format = "jpeg") {
  const photoValue = cert?.data?.photos;
  const photoId = Array.isArray(photoValue) ? photoValue[0] : photoValue;
  if (photoId == null || photoId === "") {
    return "";
  }

  const idStr = String(photoId).padStart(6, "0");
  const path1 = idStr.substring(0, 2);
  const path2 = idStr.substring(2, 4);
  const path3 = idStr.substring(4);
  return `${S3_BASE}/${CERTIFICATES_FILE_SECTION}/${path1}/${path2}/${path3}/orig.${format}`;
}

export async function getContentBrandsAndCertificates(Redis, isReset = false) {
  let shouldResetCache = isReset;

  if (Redis && typeof Redis.get === "function") {
    try {
      const currentVersion = await Redis.get(
        "nestFarkopDatabase_contentCacheVersion",
      );
      if (cachedContentVersion !== currentVersion) {
        shouldResetCache = true;
        cachedContentVersion = currentVersion;
      }
    } catch (e) {
      // ignore Redis errors here, fallback to current in-memory cache behavior
    }
  }

  if (!cachedBrands || shouldResetCache) {
    cachedBrands = await Api.databaseContent.getBrands(Redis, isReset);
  }
  if (!cachedCertificates || shouldResetCache) {
    cachedCertificates = await Api.databaseContent.getCertificates(
      Redis,
      isReset,
    );
  }

  return {
    brands: Array.isArray(cachedBrands) ? cachedBrands : [],
    certificates: Array.isArray(cachedCertificates) ? cachedCertificates : [],
  };
}

export function buildBrandByCodeAlt(codeAlt, brands) {
  if (!codeAlt) return null;
  const brand = Array.isArray(brands)
    ? brands.find(
        (b) => (b.data?.productProducer || b.productProducer) === codeAlt,
      )
    : null;
  return brand?.active && brand?.data?.image
    ? {
        id: String(brand.id),
        name: brand.name,
        detalPageUrl: `/brands/${brand.code || codeAlt}/`,
        pictureSrc:
          brand.data?.image != null ? brandImageUrl(brand.data.image) : "",
      }
    : null;
}

export function buildCertsByCodeAlt(codeAlt, certificates) {
  if (!codeAlt) return [];
  const certs = Array.isArray(certificates)
    ? certificates.filter(
        (c) => (c.data?.productProducer || c.productProducer) === codeAlt,
      )
    : [];
  return certs
    .map((c) => ({
      NAME: c.name,
      URL: getCertificateUrl(c),
    }))
    .filter((item) => item.URL);
}

export function enrichProductWithBrandAndCert(product, brands, certificates) {
  const codeAlt = product?.PROIZVODITEL_DATA?.CODE_ALT;
  const brand = buildBrandByCodeAlt(codeAlt, brands);
  const certs = buildCertsByCodeAlt(codeAlt, certificates);

  return {
    ...product,
    BRAND: brand,
    CERT: certs,
    // Для списка каталога можно переиспользовать CERT как SERT
    SERT: certs.length ? certs : product.SERT,
  };
}
